import script from "./ResetPasswordValidate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResetPasswordValidate.vue?vue&type=script&lang=ts&setup=true"

import "./ResetPasswordValidate.vue?vue&type=style&index=0&id=4a8e81f0&lang=scss"
/* custom blocks */
import block0 from "./locale/ResetPasswordValidate.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CJenkins%5Cworkspace%5CPlatformIdentity_master%5Cfrontend%5Clogin%5Csrc%5Cviews%5CResetPasswordValidate.vue&lang=yaml&external"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__